module.exports = __webpack_public_path__ + "static/img/1.f67a712b.png";